import React from 'react'

export const oregonSetupVars = {
  siteId: 'oregon',
  pathPrefix: '/or',
  menuHeader: "Discover Oregon's Solution for:",
  appUrl: 'https://or.headed2.com',
  logoImg: '/images/assets/oregon/horizontal/dark.svg',
  headerTitle: `The Oregon CareerExplorer is a system designed for Oregon`
}
